import CustomBanner from "./CustomerBanner";
import CustomerCombat from "./CustomerCombat";
import CustomersPartners from "../Home-Page/views/CustomersPartners";
import CustomerVid from "./CustomerVid";
import Advise from "../Home-Page/views/Advise";

export default function Customer() {
  return (
    <div className="w-full pt-[71px]">
      <CustomBanner />
      <CustomerCombat />
      <div className="w-full bg-[#f6f7fc]">
        <CustomersPartners />
      </div>

      <CustomerVid />
      <div id="advise">
        <Advise />
      </div>
    </div>
  );
}
